import { useQuery } from "@tanstack/react-query";
import type { GlobalMenu } from "../types";
import type { Environment } from "../../../types";
import { GLOBAL_MENU_URLS } from "../constants";
import { resolveEnvironment } from "../../../lib/environment";
import { getFallbackGlobalMenu } from "../fallback-menu";

export function useGlobalMenu(env?: Environment) {
  const resolvedEnv = resolveEnvironment(env);

  return useQuery<GlobalMenu>({
    queryKey: ["global-menu", resolvedEnv],
    queryFn: async () => {
      try {
        const res = await fetch(GLOBAL_MENU_URLS[resolvedEnv], {
          cache: "no-store",
        });
        if (!res.ok) {
          throw new Error(`Failed to fetch global menu: ${res.status}`);
        }
        return res.json();
      } catch {
        return getFallbackGlobalMenu(resolvedEnv);
      }
    },
    // Static menu fetches are intentionally not aborted when responsive roots
    // remount. Keeping the in-flight query lets the next observer reuse it.
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: false,
    refetchOnMount: true,
  });
}
